<div class="planning-break-popover">
  <rk-mobile-close-button
    class="fixed"
    [marginTopPx]="-42"
    (click)="closeSelf()"
  ></rk-mobile-close-button>
  <ng-container
    *ngIf="(currentBreak$ | async) && (isLoading$ | async) === false; else loading"
  >
    <rk-icon-button
      class="close-button hidden md:block"
      faIcon="fa-times"
      color="gray-darkest"
      [size]="26"
      (click)="closeSelf()"
    ></rk-icon-button>
    <div class="title-container">
      <ng-container *ngIf="track" class="mr-2.5">
        <img [src]="track.cover" alt="Track cover" class="w-[35px] mr-2.5" />
      </ng-container>
      <div
        *ngIf="program"
        class="program-color"
        [style.backgroundColor]="data.breakObj.color"
      ></div>
      <rk-playlist-icon
        *ngIf="playlist"
        class="playlist-color"
        [playlist]="playlist"
      ></rk-playlist-icon>
      <div class="overflow-hidden">
        <div class="title font-semibold">{{ data.breakObj.name }}</div>
        <div class="date">{{ formattedDateRange }}</div>
      </div>
    </div>
    <div class="priority">
      <div class="text-gray-darkest mr-4 font-semibold">
        {{ (currentBreak$ | async)?.priority }}
      </div>
      <div class="priority-text" translate>
        SCHEDULE.PLANNING.BREAK_POPOVER_PRIORITY_LABEL
      </div>
    </div>
    <div
      class="repeat"
      *ngIf="
        (currentBreak$ | async)?.dailyRepeat ||
        (currentBreak$ | async)?.repeat?.repeatDays
      "
    >
      <mat-icon
        class="repeat-icon"
        fontSet="fas"
        fontIcon="fa-redo"
        [inline]="true"
      ></mat-icon>
      <div class="repeat-text">
        <ng-container *ngIf="(currentBreak$ | async)?.dailyRepeat">
          {{
            'SCHEDULE.PLANNING.BREAK_POPOVER_REPEAT_MINS'
              | translate
                : {
                    min: (currentBreak$ | async).repeatPerDay.repeatInterval,
                  }
          }}
        </ng-container>
        <div
          class="text-gray-darkest"
          *ngIf="(currentBreak$ | async)?.repeat?.repeatDays"
        >
          {{ repeatWeekday }}
        </div>
      </div>
    </div>
    <div class="actions mt-5 md:mt-7.5">
      <rk-button
        class="actions-button"
        [fullWidth]="data.mobile"
        [label]="'SCHEDULE.PLANNING.DELETE_BREAK' | translate"
        [btnStyle]="'orangeText'"
        (click)="deletionClicked()"
      ></rk-button>
      <rk-button
        class="actions-button"
        [fullWidth]="data.mobile"
        [label]="'SCHEDULE.PLANNING.EDIT_BREAK' | translate"
        (click)="editionClicked()"
      ></rk-button>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <rk-loader
    class="block my-8"
    [center]="true"
    [size]="60"
    [isLoading]="true"
  ></rk-loader>
</ng-template>
